// DO NOT MODIFY, this file is autogenerated by tools/build.ts
// Export a null object with the same keys as firebase/compat/remote-config, so Proxy can work with proxy-polyfill in Internet Explorer
export const proxyPolyfillCompat = {
  app: null,
  settings: null,
  defaultConfig: null,
  fetchTimeMillis: null,
  lastFetchStatus: null,
  activate: null,
  ensureInitialized: null,
  fetch: null,
  fetchAndActivate: null,
  getAll: null,
  getBoolean: null,
  getNumber: null,
  getString: null,
  getValue: null,
  setLogLevel: null,
};
